__webpack_require__.p = "https://myd3s-static.s3.ap-southeast-2.amazonaws.com/";